<template>
  <div class="legal__page">
    <redirect class="" title="Settings" route="website.settings" />
    <v-row no-gutters>
      <v-col class="page-header d-flex align-center" cols="12">
        <h2 class="page-title mb-0">Legal</h2>
        <v-spacer></v-spacer>
        <v-btn @click="showAddLanguageDialog = true" color="success" outlined>
          <v-icon left>mdi-plus</v-icon>
          Add Language
        </v-btn>
      </v-col>
      <v-col cols="12" v-if="isLoading">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" v-else>
        <v-row>
          <v-col cols="4">
            <h3>Legal pages</h3>
            <p>
              Legal pages You can create your own legal pages, or create them from templates and customize. By using
              these templates you agree that you've read and agreed to the disclaimer.
            </p>
          </v-col>
          <v-col cols="8" class="elevation-form">
            <div class="d-flex align-center mb-3">
              <v-icon color="primary" class="mr-2" size="28">mdi-web</v-icon>
              <h3 class="mb-0">Default Legal Pages</h3>
              <v-chip small color="primary" class="ml-2">Primary</v-chip>
            </div>
            <v-divider class="mb-4"></v-divider>
            <div>
              <h4>Refund policy</h4>
              <p>
                When saved, customers can see a link to this on checkout footer, order review page, and menus
                (optional).
              </p>
              <v-textarea v-model="legal.refundPolicy"></v-textarea>
              <v-btn @click="legal.refundPolicy = refundPolicyTemplate" class="mt-5" color="primary"
                >Create template</v-btn
              >
              <v-divider class="my-5"></v-divider>
            </div>
            <div>
              <h4>Privacy policy</h4>
              <p>When saved, customers can see a link to this on checkout footer and menus (optional)</p>
              <v-textarea v-model="legal.privacyPolicy"></v-textarea>
              <v-btn @click="legal.privacyPolicy = privacyPolicyTemplate" class="mt-5" color="primary"
                >Create template</v-btn
              >
              <v-divider class="my-5"></v-divider>
            </div>
            <div>
              <h4>Terms of Services</h4>
              <p>When saved, customers can see a link to this on checkout footer and menus (optional)</p>
              <v-textarea v-model="legal.termOfServicePolicy"></v-textarea>
              <v-btn @click="legal.termOfServicePolicy = termOfServicePolicyTemplate" class="mt-5" color="primary"
                >Create template</v-btn
              >
              <v-divider class="my-5"></v-divider>
            </div>
            <div>
              <h4>Shipping policy</h4>
              <p>
                When saved, customers can see a link to this on product pages, cart, checkout, checkout footer, and
                menus (optional).
              </p>
              <v-textarea v-model="legal.shippingPolicy"></v-textarea>
              <v-btn @click="legal.shippingPolicy = shippingPolicyTemplate" class="mt-5" color="primary"
                >Create template</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- Language Legal Pages -->
      <template v-if="!isLoading && legal.languages && legal.languages.length > 0">
        <v-col cols="12" class="mt-5" v-for="(lang, index) in legal.languages" :key="lang.lang">
          <v-row>
            <v-col cols="4">
              <div class="d-flex align-center mb-3">
                <v-icon color="success" class="mr-2" size="28">mdi-translate</v-icon>
                <h3 class="mb-0">{{ getLanguageLabel(lang.lang) }}</h3>
                <v-chip small color="success" outlined class="ml-2">{{ lang.lang.toUpperCase() }}</v-chip>
              </div>
              <p class="mt-3">Customize legal pages for {{ getLanguageLabel(lang.lang) }} customers.</p>
              <v-btn icon color="error" @click="confirmDeleteLanguage(lang.lang, index)" class="mt-2">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="8" class="elevation-form">
              <div>
                <h4>Refund policy</h4>
                <p>
                  When saved, customers can see a link to this on checkout footer, order review page, and menus
                  (optional).
                </p>
                <v-textarea v-model="lang.refundPolicy"></v-textarea>
                <v-btn @click="lang.refundPolicy = refundPolicyTemplate" class="mt-5" color="primary"
                  >Create template</v-btn
                >
                <v-divider class="my-5"></v-divider>
              </div>
              <div>
                <h4>Privacy policy</h4>
                <p>When saved, customers can see a link to this on checkout footer and menus (optional)</p>
                <v-textarea v-model="lang.privacyPolicy"></v-textarea>
                <v-btn @click="lang.privacyPolicy = privacyPolicyTemplate" class="mt-5" color="primary"
                  >Create template</v-btn
                >
                <v-divider class="my-5"></v-divider>
              </div>
              <div>
                <h4>Terms of Services</h4>
                <p>When saved, customers can see a link to this on checkout footer and menus (optional)</p>
                <v-textarea v-model="lang.termOfServicePolicy"></v-textarea>
                <v-btn @click="lang.termOfServicePolicy = termOfServicePolicyTemplate" class="mt-5" color="primary"
                  >Create template</v-btn
                >
                <v-divider class="my-5"></v-divider>
              </div>
              <div>
                <h4>Shipping policy</h4>
                <p>
                  When saved, customers can see a link to this on product pages, cart, checkout, checkout footer, and
                  menus (optional).
                </p>
                <v-textarea v-model="lang.shippingPolicy"></v-textarea>
                <v-btn @click="lang.shippingPolicy = shippingPolicyTemplate" class="mt-5" color="primary"
                  >Create template</v-btn
                >
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
        </v-col>
      </template>

      <v-col cols="12" class="mt-5 text-end">
        <v-btn
          :disabled="isLoadingAction || isLoading"
          :loading="isLoadingAction || isLoading"
          @click="submit"
          color="primary"
          >Save</v-btn
        >
      </v-col>
    </v-row>

    <!-- Modal add language -->
    <v-dialog v-model="showAddLanguageDialog" max-width="500px">
      <v-card>
        <p style="font-size: 20px; padding-top: 14px; padding-left: 14px;">Add New Language</p>
        <v-card-text>
          <v-select
            v-model="newLanguageCode"
            :items="languageOptions"
            item-text="label"
            item-value="code"
            label="Select Language"
            outlined
            :error-messages="languageError"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelAddLanguage">Cancel</v-btn>
          <v-btn color="primary" :loading="isAddingLanguage" @click="addNewLanguage">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { settingsApi } from '@/apis/settings';
import event from '@/plugins/event-bus';

export default {
  data() {
    return {
      legal: {
        refundPolicy: '',
        privacyPolicy: '',
        termOfServicePolicy: '',
        shippingPolicy: '',
        languages: [], // Multi-language support
      },
      // Multi-language support
      showAddLanguageDialog: false,
      newLanguageCode: '',
      languageError: '',
      isAddingLanguage: false,
      languageOptions: [
        { code: 'en', label: 'English (EN)' },
        { code: 'us', label: 'English (US)' },
        { code: 'eu', label: 'European (EU)' },
        { code: 'es', label: 'Spanish (ES)' },
        { code: 'fr', label: 'French (FR)' },
        { code: 'de', label: 'German (DE)' },
        { code: 'it', label: 'Italian (IT)' },
        { code: 'pt', label: 'Portuguese (PT)' },
        { code: 'ja', label: 'Japanese (JA)' },
        { code: 'ko', label: 'Korean (KO)' },
        { code: 'zh', label: 'Chinese (ZH)' },
        { code: 'vi', label: 'Vietnamese (VI)' },
      ],
      refundPolicyTemplate: `RETURN

Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can’t offer you a refund or exchange.
To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.
Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.

Additional non-returnable items:
- Gift cards
- Downloadable software products
- Some health and personal care items

To complete your return, we require a receipt or proof of purchase.
Please do not send your purchase back to the manufacturer.

There are certain situations where only partial refunds are granted (if applicable):
- Book with obvious signs of use
- CD, DVD, VHS tape, software, video game, cassette tape, or vinyl record that has been opened
- Any item not in its original condition, is damaged or missing parts for reasons not due to our error
- Any item that is returned more than 30 days after delivery

----

REFUNDS (IF APPLICABLE)

Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.
If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.

LATE OR MISSING REFUNDS (IF APPLICABLE)

If you haven’t received a refund yet, first check your bank account again.
Then contact your credit card company, it may take some time before your refund is officially posted.
Next contact your bank. There is often some processing time before a refund is posted.
If you’ve done all of this and you still have not received your refund yet, please contact us at {{shop.customer_email}}.

SALE ITEMS (IF APPLICABLE)

Only regular priced items may be refunded, unfortunately sale items cannot be refunded.

----

EXCHANGES (IF APPLICABLE)

We only replace items if they are defective or damaged.  If you need to exchange it for the same item, send us an email at {{shop.customer_email}} and send your item to: {{shop.address}}.

----

GIFTS

If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. Once the returned item is received, a gift certificate will be mailed to you.
If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.

SHIPPING

To return your product, you should mail your product to: {{shop.address}}
You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.
Depending on where you live, the time it may take for your exchanged product to reach you, may vary.
If you are shipping an item over $75, you should consider using a trackable shipping service or purchasing shipping insurance. We don’t guarantee that we will receive your returned item.

`,
      privacyPolicyTemplate: `This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from {{shop.name}} (the “Site”).

----

PERSONAL INFORMATION WE COLLECT

When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as “Device Information”.

We collect Device Information using the following technologies:

- “Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit http://www.allaboutcookies.org.
- “Log files” track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.
- “Web beacons”, “tags”, and “pixels” are electronic files used to record information about how you browse the Site.

Additionally when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers), email address, and phone number. We refer to this information as “Order Information”.

When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Order Information.

----

HOW DO WE USE YOUR PERSONAL INFORMATION?

We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations). Additionally, we use this Order Information to:

- Communicate with you;
- Screen our orders for potential risk or fraud; and
- When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.

We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns).

----

SHARING YOUR PERSONAL INFORMATION

We share your Personal Information with third parties to help us use your Personal Information, as described above. For example, we also use Google Analytics to help us understand how our customers use the Site -- you can read more about how Google uses your Personal Information here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.

Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful requests for information we receive, or to otherwise protect our rights.

----

BEHAVIORAL ADVERTISING

As described above, we use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you. For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (“NAI”) educational page at http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.

You can opt-out of targeted advertising by using the links below:

- Facebook: https://www.facebook.com/settings/?tab=ads
- Google: https://www.google.com/settings/ads/anonymous
- Bing: https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads

Additionally, you can opt-out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal at http://optout.aboutads.info/.

----

DO NOT TRACK

Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.

----

YOUR RIGHTS

If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.
Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above. Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.

----

DATA RETENTION

When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.

----

CHANGES

We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.

----

CONTACT US

For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e‑mail at {{shop.customer_email}}

{{shop.name}}
[Re: Privacy Compliance Officer]`,
      termOfServicePolicyTemplate: `OVERVIEW

This website is operated by {{shop.name}}. Throughout the site, the terms “we”, “us” and “our” refer to {{shop.name}}. {{shop.name}} offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.

By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply  to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.

Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.

Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.

----

SECTION 1 - ONLINE STORE TERMS

By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.

You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
You must not transmit any worms or viruses or any code of a destructive nature.

A breach or violation of any of the Terms will result in an immediate termination of your Services.

----

SECTION 2 - GENERAL CONDITIONS

We reserve the right to refuse service to anyone for any reason at any time.

You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.

You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.

The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.

----

SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION

We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.

This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.

----

SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES

Prices for our products are subject to change without notice.

We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.

We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.

----

SECTION 5 - PRODUCTS OR SERVICES (if applicable)

Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.

We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.

We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited.

We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.

----

SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION

We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e‑mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.

You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.

For more detail, please review our Returns Policy.

----

SECTION 7 - OPTIONAL TOOLS

We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.

You acknowledge and agree that we provide access to such tools ”as is” and “as available” without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools.

Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s).

We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.

----

SECTION 8 - THIRD-PARTY LINKS

Certain content, products and services available via our Service may include materials from third-parties.

Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.

We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.

----

SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS

If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.

We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party’s intellectual property or these Terms of Service.
You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e‑mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.

----

SECTION 10 - PERSONAL INFORMATION

Your submission of personal information through the store is governed by our Privacy Policy. To view our Privacy Policy.

----

SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS

Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).

We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated.

----

SECTION 12 - PROHIBITED USES

In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.

----

SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY

We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.

We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.

You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you.

You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.

In no case shall {{shop.name}}, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.

----

SECTION 14 - INDEMNIFICATION

You agree to indemnify, defend and hold harmless {{shop.name}} and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.

----

SECTION 15 - SEVERABILITY

In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.

----

SECTION 16 - TERMINATION

The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes.

These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.

If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).

----

SECTION 17 - ENTIRE AGREEMENT

The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.

These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).

Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.

----

SECTION 18 - GOVERNING LAW

These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of the United States.

----

SECTION 19 - CHANGES TO TERMS OF SERVICE

You can review the most current version of the Terms of Service at any time at this page.

We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.

----

SECTION 20 - CONTACT INFORMATION

Questions about the Terms of Service should be sent to us at {{shop.customer_email}}.`,
      shippingPolicyTemplate: `HOW MUCH DOES SHIPPING COST?

Shipping costs vary depending on the shipping destination and the number of items that you purchase. You can get a calculation of your exact shipping charges by adding items to your cart, proceeding to checkout, and entering your mailing address. The shipping cost will automatically update and display in your total costs.

----

WHERE DO WE DELIVER?

We provide worldwide shipping.

----

HOW LONG WILL IT TAKE FOR THE BUYER TO RECEIVE THEIR ORDER?

On average, merchandise is produced and shipped from our facility 5-7 business days after purchase. Standard shipping/transit times apply (5-10 days for domestic and 7-15 days for international).

----

CAN THE ORDER BE DELIVERED TO MULTIPLE ADDRESSES?

We do not offer the shipment to multiple addresses for a single order. If you would like items delivered to multiple addresses, please place those orders separately.

----

DO YOU OFFER DELIVERY TO PO BOXES OR MILITARY APO/FPO ADDRESSES?

Yes, we can send shipments to PO Boxes and Military APO/FPO addresses.

----

WILL I BE CHARGED VAT TAXES?

Items shipping internationally from the US are shipped DDU (Delivered Duty Unpaid) and we do not collect VAT (Value Added Taxes). All taxes, duties, and customs fees are the responsibility of the recipient of the package.

Depending on the receiving country, your package may incur local customs or VAT charges. We recommend contacting your local customs office for more information regarding your country's customs policies.`,
      isLoading: false,
      isLoadingAction: false,
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    event.$emit('getStepStatus', message => {
      this.getStep();
    });
  },
  methods: {
    /*
      Get language label from code
    */
    getLanguageLabel(code) {
      const option = this.languageOptions.find(opt => opt.code === code);
      return option ? option.label : code.toUpperCase();
    },
    /*
      Cancel add language
    */
    cancelAddLanguage() {
      this.showAddLanguageDialog = false;
      this.newLanguageCode = '';
      this.languageError = '';
    },
    /*
      Add new language
    */
    async addNewLanguage() {
      if (!this.newLanguageCode) {
        this.languageError = 'Please select a language';
        return;
      }

      // Check if language already exists
      const exists = this.legal.languages?.some(lang => lang.lang === this.newLanguageCode);
      if (exists) {
        this.languageError = 'This language already exists';
        return;
      }

      this.isAddingLanguage = true;

      try {
        // Clone current default legal structure
        const newLangData = {
          lang: this.newLanguageCode,
          refundPolicy: this.legal.refundPolicy,
          privacyPolicy: this.legal.privacyPolicy,
          termOfServicePolicy: this.legal.termOfServicePolicy,
          shippingPolicy: this.legal.shippingPolicy,
        };

        if (!this.legal.languages) {
          this.legal.languages = [];
        }

        this.legal.languages.push(newLangData);

        // Close dialog
        this.showAddLanguageDialog = false;
        this.newLanguageCode = '';
        this.languageError = '';

        this.$forceUpdate();
      } catch (error) {
        console.error('Error adding language:', error);
        this.languageError = 'Failed to add language';
      } finally {
        this.isAddingLanguage = false;
      }
    },
    /*
      Confirm delete language
    */
    confirmDeleteLanguage(langCode, index) {
      if (confirm(`Are you sure you want to delete ${this.getLanguageLabel(langCode)} version?`)) {
        this.deleteLanguage(index);
      }
    },
    /*
      Delete language
    */
    deleteLanguage(index) {
      this.legal.languages.splice(index, 1);
      this.$forceUpdate();
    },
    setContent(content) {},
    async loadData() {
      this.isLoading = true;
      try {
        let data = await settingsApi.getLegal();
        this.legal = data.data;
        // Initialize languages array if not exists
        if (!this.legal.languages) {
          this.legal.languages = [];
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async submit() {
      this.isLoadingAction = true;
      try {
        // Prepare legal data with languages
        const legalDataToSave = {
          ...this.legal,
          languages: this.legal.languages || [],
        };
        let data = await settingsApi.updateLegal(legalDataToSave);
        this.isLoadingAction = false;
      } catch (error) {
        this.isLoadingAction = false;
      }
    },
  },
};
</script>
